export default function SignIn() {
    return (
        <div className="signin">
            <div className="signin-card">
                <h1>Infra Versions</h1>
                <p className="muted">Sign in to view cluster versions and promotions.</p>
                <a className="btn btn-primary" href="/auth/login">
                    Sign in with GitLab
                </a>
            </div>
        </div>
    );
}
